import React from 'react';
import webapi from '../../../api/webapi';
import PerSurfSearchBox from './PerSurfSearchBox';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

class PersianSurf extends React.Component {
    state = { SearchtabIndex : 0}
    state = { LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}] }
    
    componentDidMount(){
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         this.setLog('pages/log/PersianSurf/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => this.setLog('pages/log/PersianSurf/visit/'+err));
    }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/801/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/801/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    }

    onSelectTab = (val) => {
        this.setState({
            SearchtabIndex: val  
        })
    }

    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return (
                <div>
                    <Header LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                        <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F801!== undefined?this.state.pageData[0].F801:801/*جستجوی متن*/}</h1>
                        <h2 id="page_title_dek">{this.state.pageData.length!==0 && this.state.pageData[0].F80100!== undefined?this.state.pageData[0].F80100:80100/*آوانویسی و ترجمه فارسی متون فارسی میانه*/}</h2>
                        <hr className="halfwidth" />
                        </div>
                    </div>
                    <PerSurfSearchBox   tabIndex={this.state.SearchtabIndex} 
                                        onSelectTab={this.onSelectTab}
                                        pageData={this.state.pageData}
                                        Lang = {this.state.LanguageInfo[0].Code}
                    />
                    <br />
                    <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                </div>
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default PersianSurf;